import React from 'react'
import {MdDelete} from 'react-icons/md';
import {Button, Media} from "reactstrap";
import businessHelper from "../../helpers/BusinessHelper";

const propTypes = {};

class TeamMemberTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            member: props.member,
        };
    }

    deleteMember(e) {
        e.preventDefault();

        this.props.deleteMember(this.state.member)
    }

    render() {
        return (
            <tr>
                <th scope="row">
                    <Media className="align-items-center">
                        <Media>
                            <span className="mb-0 text-sm">
                                {this.state.member && this.state.member.name ? this.state.member.name : "..."}
                                <div>
                                    <small>{this.state.member && this.state.member.email ? this.state.member.email : "..."}</small>
                                </div>
                            </span>
                        </Media>
                    </Media>
                </th>
                <td>
                    <span className="mb-0 text-sm">
                        {this.getRole()}
                    </span>
                </td>

                <td className="text-center">
                    {this.state.member.locale_id &&
                    <Button className="btn-secondary" color="secondary"
                            size="sm"
                            onClick={e => this.showLocales(e)}>
                        {this.memberLocale()}
                    </Button>
                    }
                </td>

                <td className="text-right align-content-end">
                    {this.state.member.master_user &&
                    <Button className="btn-icon" color="warning"
                            onClick={e => this.deleteMember(e)}>
                        <MdDelete/>
                    </Button>
                    }
                </td>
            </tr>
        )
    }

    showLocales(e) {
        this.props.showLocales(e, this.state.member)
    }

    getRole() {
        switch (this.state.member.roles) {
            case "t":
                return businessHelper.teamMemberTypes()[1].label;
            case "a":
                return businessHelper.teamMemberTypes()[0].label;
            case "tl":
                return businessHelper.teamMemberTypes()[2].label;
            case "al":
                return businessHelper.teamMemberTypes()[3].label;
            default:
                return "";
        }

    }

    memberLocale() {
        const locId = this.state.member.locale_id;
        if (locId) {
            const businessLocales = businessHelper.businessLocales()

            if (businessLocales) {
                const loc = businessLocales.find((l) => {
                    return l.id == locId
                })
                return loc.title
            }
        }
    }
}

TeamMemberTableRow.propTypes = propTypes;

export default TeamMemberTableRow;